import _objectSpread from "C:\\vstsagent\\multiCribis-build-agent\\_work\\58\\s\\Source\\Crif.BlueBabylon.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import platform from './node/index.js';
import * as utils from './common/utils.js';
export default _objectSpread({}, utils, platform);